import { MemberDetailsDto, MemberDetailsDtoImpl } from '../listtones/memberdetailsdto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
export class ViewBlacklistBuilder
{
    constructor(private blacklistList: any)
    {
         if(blacklistList.bPartyDetailsList === undefined)
        {
            throw new NoDataException("Get Blacklist data doesnt exists");
        }
    }

    buildAll(): MemberDetailsDto[]
    {
        return this.parseViewBlacklistDetailsResponse();
    }
    
    private parseViewBlacklistDetailsResponse(): MemberDetailsDto[]
    {
        let listOfBlacklist: MemberDetailsDto[] = [];
        
        let blacklistDetailsResponse = null;
        this.blacklistList.bPartyDetailsList.forEach((blacklistMemberItem: any) =>
        {
            blacklistDetailsResponse = new MemberDetailsDtoImpl();
            blacklistDetailsResponse.setMemberName(blacklistMemberItem.bPartyName);
            blacklistDetailsResponse.setMsisdn(blacklistMemberItem.bPartyMsisdn);
            
            listOfBlacklist.push(blacklistDetailsResponse);
        });
        return listOfBlacklist;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/viewblacklist/viewblacklistbuilder.ts